import React, { useState } from 'react';

const formatTimestamp = (iso) => {
    try {
        return new Date(iso).toLocaleString();
    } catch {
        return iso;
    }
};

const LogViewer = ({ log, index = null }) => {
    const [expanded, setExpanded] = useState(false);
    if (!log) return null;

    const toggle = () => setExpanded(prev => !prev);

    return (
        <div
            className="p-4 border rounded shadow-md bg-white text-sm space-y-1 cursor-pointer hover:shadow-lg transition"
            onClick={toggle}
        >
            {!expanded ? (
                <div className="text-gray-800">
                    <strong>{log.act}</strong> by {log.privateName} {log.lastName} on {formatTimestamp(log.timestamp)} – Status {log.statusCode}
                </div>
            ) : (
                <>
                    {index !== null && <div className="font-bold text-blue-600">Log Entry #{index}</div>}
                    <div><strong>Timestamp:</strong> {formatTimestamp(log.timestamp)}</div>
                    <div><strong>Action:</strong> {log.act}</div>
                    <div><strong>User:</strong> {log.privateName} {log.lastName} (ID: {log.userID})</div>
                    <div><strong>Approver:</strong> {log.privateNameApprover} {log.lastNameApprover} (ID: {log.approverID})</div>
                    <div><strong>Type:</strong> {log.approvertype}</div>
                    <div><strong>Business ID:</strong> {log.businessID}</div>

                    {Array.isArray(log.businessNames) && log.businessNames.length > 0 && (
                        <div>
                            <strong>Business Names:</strong>
                            <ul className="list-disc list-inside ml-4">
                                {log.businessNames.map((biz, i) => (
                                    <li key={i}>{biz.name} (ID: {biz.id})</li>
                                ))}
                            </ul>
                        </div>
                    )}

                    <div><strong>Status Code:</strong> {log.statusCode}</div>
                    <div><strong>Tried As Admin:</strong> {log.triedAsAdmin ? 'Yes' : 'No'}</div>
                    <div><strong>Admin Status Code:</strong> {log.adminStatusCode ? 'Yes' : 'No'}</div>
                </>
            )}
        </div>
    );
};

export default LogViewer;
